const styles = (theme) => ({
  root: {
    width: '100%',
    display: 'inline-block',
    wordBreak: 'break-all',
  },
});

export default styles;
